module.exports = __webpack_public_path__ + "img/CIA.c847d309.jpg";